<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> 
                   
                    <h3 class="mb-0">
                        {{ $t('message.manuscritConsultations') }}
                    </h3>
                </div>
            </div>

            <div class="">
                <b-row>
                    <b-col col sm="8">
                        <div class="list-group">
                            <b-row>
                                <b-col col sm="12" class="mb-3">
                                    <div class="">
                                        <h4 class="consultation-item__title"> {{ $t('message.institutionConsultation') }} </h4>
                                        <span class="font-weight-bold">
                                                    <p class="consultation-item__body"> {{ etablissement }} </p>
                                                </span>
                                    </div>
                                </b-col>
                                <b-col col sm="12" class="mb-3">
                                    <div class="">
                                        <h4 class="consultation-item__title"> {{ $t('message.typeOfConsultation') }} </h4>
                                        <span class="font-weight-bold">
                                                    <p class="consultation-item__body"> {{ mConsultation.name == 'null' ? mConsultation.consultation_externe : mConsultation.name }} </p>
                                                </span>
                                    </div>
                                </b-col>
                                <b-col col sm="12" class="mb-3">
                                    <div class="">
                                        <h4 class="consultation-item__title"> {{ $tc('message.practitioners',1) }} </h4>
                                        <span class="font-weight-bold">
                                                    <p class="consultation-item__body"> {{ praticien }} </p>
                                                </span>
                                    </div>
                                </b-col>
                                <b-col col sm="12" class="mb-3">
                                    <div class="">
                                        <h4 class="consultation-item__title">{{ $t('message.consultationDate') }} </h4>

                                        <p class="consultation-item__body"> {{ formattedDate(mConsultation.date_consultation) }} </p>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col col sm="12">
                                    <h4 class="consultation-item__title">Fichier joint </h4>
                                    <div v-if="files.length>0">
                                        <div  v-for="file in files" :key="file.id">
                                            <b-row>
                                                <b-col col sm="6">
                                                    <p class="mb-3"> {{file.nom}}</p>
                                                </b-col>
                                                <b-col col sm="6">
                                                    <!-- <button type="button" class=" ml-5 btn btn-success btn-sm" @click="openFile(file)">
                                                        <i class="fa fa-print"></i> {{ $t('message.visualiser') }}
                                                    </button> -->
                                                    <h3>
                                                        <b-link variant="outline-success" @click="openFile(file)" style="color: #2dcecc">
                                                            <i class="fa fa-print fa-1x"></i> {{ $t('message.visualiser') }}
                                                        </b-link>
                                                    </h3>
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                    <b-col col sm="4">
                        <b-row class="justify-content-sm-center">
                            <div class="card-footer text-right">
                                <b-button variant="primary" @click="updateConsultation" v-if="canUpdate">
                                    {{ $t('message.edit') }}
                                </b-button>
                                
                                <br>
                                <b-button variant="success" @click="archieveConsultation" v-if="!isTransmitted(mConsultation.passed_at) && isArchived(mConsultation.archieved_at) && (hasMedecinControleRole || hasAdminRole || hasAssistante)" >
                                    {{ $t('message.archieve') }}
                                </b-button>
                                <br>
                                <b-button variant="info" @click="transmitConsultation" v-if="isTransmitted(mConsultation.passed_at) && mConsultation.isAuthor && (hasPraticienRole || hasAdminRole || hasMedecinControleRole || hasAssistante)">
                                    {{ $t('message.transmit') }}
                                </b-button>
                                <br>

                                <b-button variant="info" @click="reactiveConsultation" v-if="canReactive">
                                    {{ $t('message.reavivate') }} {{$tc('message.consultations',1) }}
                                </b-button>
                                <br>
                            
                                <b-button v-b-modal.delete-modal variant="danger" v-if="canDelete">
                                    {{ $t('message.delete') }}
                                </b-button>
                                <br>
                                <p v-if="errorshasField('nonTransmis')" style="color:red"  class="justify-content-sm-center">
                                    {{getErrorsField('nonTransmis')}}
                                </p>
                            </div>
                        </b-row>
                    </b-col>
                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $t('message.manuscritConsultations')"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{$t('message.manuscritConsultations')}} {{ mConsultation.name }}</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteConsultation" >
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import AppConfig from "../../../constants/AppConfig";
    import moment from "moment";
    import $ from "jquery";

    export default {
        name: "Manuscrit",
        computed: {
            ...mapGetters([
                "manuscrit",
                'errors',
                'hasAdminRole',
                'hasMedecinControleRole','hasAssistante',
                "hasSouscripteurRole",
                "hasPatientRole",
                'hasPraticienRole',
                'hasGestionnaireRole']),

            image: function () {
                if (!_.isUndefined(this.mConsultation.file) && !_.isNull(this.mConsultation.file)) {
                    if (this.mConsultation.file.length > 0 && this.mConsultation.file != 'null') {
                        return AppConfig.imgUrl + '/public/storage/' + this.mConsultation.file;
                    }
                    return "";
                }
                return "";
            },

            mConsultation: function() {
                return this.manuscrit;
            },

            files:function(){
                return _.isUndefined(this.mConsultation.files) ? [] :this.mConsultation.files;
            },

            isAuthor:function(){
                return this.mConsultation.isAuthor;
            },

            canUpdate:function(){
                return this.mConsultation.canUpdate;
            },

            canReactive:function(){
                return !_.isNull(this.mConsultation.passed_at) && (this.hasAdminRole || this.hasMedecinControleRole || this.hasAssistante);
            },

            canDelete:function(){
                if (this.hasAdminRole)
                    return true;

                return this.mConsultation.canUpdate && _.isNull(this.mConsultation.archieved_at) && _.isNull(this.mConsultation.passed_at);
            },

            etablissement:function(){
                if (!_.isUndefined(this.mConsultation)){
                    if (!_.isUndefined(this.mConsultation.etablissement)){
                        if (!_.isNull(this.mConsultation.etablissement)){
                            return this.mConsultation.etablissement.name;
                        }
                        return "";
                    }
                }
                return  "";
            },

            praticien:function(){
                if (!_.isNull(this.mConsultation.praticien)){
                    let praticien = this.mConsultation.praticien;
                        if (!_.isUndefined(praticien) && !_.isNull(praticien)) {
                            let prenom = (praticien.prenom == null) ? '' : praticien.prenom;
                            return (praticien.nom).toUpperCase() + " " +prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        }
                }
                return  this.mConsultation.praticien_externe;
            },
        },
        data() {
            return {
                consultation_id: this.$route.params.consultation,

            }
        },

        methods: {
            openFile(file) {
                window.open(AppConfig.imgUrl + '/public/storage/' + file.chemin);
            },

            getConsultation() {
                let args = {
                    consultation: this.consultation_id
                };

                this.$store.dispatch("getManuscrit", { args });
            },

            formattedDate(date) {
                return moment(date).format('DD-MM-YYYY');
            },

            updateConsultation() {
                this.$router.push({ name: 'edit-consultation-manuscrit', params: { consultation: this.consultation_id } });
            },

            deleteConsultation() {
                let self = this;
                let args = {
                    consultation: this.consultation_id
                };

                let successMessage = this.$i18n.t('message.manuscritConsultationsDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteManuscrit', { args, index: self.consultation_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            },

            archieveConsultation(){
                let self = this;
                let args = {
                    consultation: this.consultation_id
                };

                let successMessage = this.$i18n.t('message.manuscritConsultationArchieved');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('archieveManuscrit', { args, index: self.consultation_id, successMessage, errorMessages });

            },

            transmitConsultation(){
                let self = this;
                let args = {
                    consultation: this.consultation_id
                };

                let successMessage = this.$i18n.t('message.manuscritConsultationTransmitted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('transmitManuscrit', { args, index: self.consultation_id, successMessage, errorMessages });

            },

            reactiveConsultation(){
                let self = this;
                let args = {
                    consultation: this.consultation_id
                };

                let successMessage = this.$i18n.t('message.manuscritConsultationReactived');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('reactiveManuscrit', { args, index: self.consultation_id, successMessage, errorMessages });

            },

            isArchived:function(date){
                let momentDate = moment(date);
                return !momentDate.isValid() ;
            },

            isTransmitted:function(date){
                var momentDate = moment(date);
                return !momentDate.isValid() ;
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },
            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },
            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            },
            pathHas(element){
                let result = (this.$route.fullPath).includes(element);
                if(result){
                    if ($('#'+element).length){
                        document.getElementById(element).scrollIntoView(top);
                    }
                }

                return result;
            }
        },

        mounted() {
            this.getConsultation();
        }
    }
</script>

<style scoped>

</style>